import { render, staticRenderFns } from "./customerPrice.vue?vue&type=template&id=10f335e9&scoped=true"
import script from "./customerPrice.vue?vue&type=script&lang=js"
export * from "./customerPrice.vue?vue&type=script&lang=js"
import style0 from "./customerPrice.vue?vue&type=style&index=0&id=10f335e9&prod&lang=stylus&scoped=true"
import style1 from "./customerPrice.vue?vue&type=style&index=1&id=10f335e9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f335e9",
  null
  
)

export default component.exports